import React from 'react';
import IconPrint from "react-icons/lib/fa/print";
import ReactToPrint from "react-to-print";

export default (props) => {

    const goBack = () => {
        props.goBackHandler();
    }
    return (
    <div className="view-header">
        <div className="kr-header">
            <div className="kr-header__title back-icon">
                {
                    props.changeStatusButtons ?
                        <div className="header-case-status">
                            <span>Status: </span>
                            {props.status === 'onhold' ? 'On hold' : props.status}
                        </div>
                        : ''
                }
                {props.showBackIcon && (
                    <button
                        className="back-to"
                        data-toggle="tooltip"
                        onClick={goBack}
                        title={props.title}
                    >
                        <span className="kr kr-arrow"/>
                    </button>)
                }
                <h5 className="">{props.header}</h5>
                {
                    props.changeStatusButtons ?
                        <div className='case_inner_actions'>
                            {props.buttonsFunctionality}
                        </div>
                        : ''
                }
            </div>
            <div className="kr-header__actions">
                {props.showVacationsButton &&
                    <button
                        className="btn btn-link mx-3"
                        onClick={props.openVacationsModal}
                        type='button'
                    >
                        Vacation Days
                    </button>
                }
                {props.showDelete &&
                    <button
                        className="btn delete_button"
                        onClick={props.handleDelete}
                        type='button'
                    >
                        <span className="kr kr-delete"/>
                        Delete Case
                    </button>
                }
                {props.showPrint && <ReactToPrint
                    trigger={() => <a className="btn btn-link"><span className="kr kr-print"/>Print</a>}
                    content={() => props.printRef()}
                />}
                <div>
                    {props.showPrimary && <button onClick={() => props.openConvertModal()}
                                                  className="btn btn-primary">{props.primaryButtonName}</button>}
                    {props.showSecondary && <button onClick={() => props.openModal()} disabled={props.disabled}
                                                    className="btn btn-secondary">{props.secondaryButtonName}</button>}
                </div>
                {props.showSaveButton && (
                    <div>
                        <button
                            className="btn no-shadow-btn btn-save btn-primary"
                            disabled={props.saveDisabled}
                            onClick={props.handleSave}>
                            {'Save'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    </div>
    )
};



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/view-header.js